import React from 'react';
import LCVHelpButton from './LCVHelpButton';

const WorkbookReadyPhase = ({
  workbook,
  workbookState,
  onReady,
  onDone,
  navigationDisabled = false,
}) => {
  const wb = workbook;
  const isReady = workbookState.ready;

  return (
    <div className="lcv-work-panel">
      <LCVHelpButton phase="workbook_ready" />
      <div className="lcv-work-badge">
        <span className="lcv-work-dot" />
        WORKBOOK
      </div>

      <div className="lcv-work-exercise-label">
        <span className="lcv-work-page-icon">📖</span>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 0.5 }}>Open your workbook to</div>
          <div className="lcv-work-page-number">{wb.exerciseLabel}</div>
        </div>
      </div>

      {!isReady && (
        <button
          className="lcv-btn-primary lcv-btn-full"
          onClick={onReady}
          disabled={navigationDisabled}>
          I'm Ready →
        </button>
      )}

      {isReady && (
        <>
          <div className="lcv-work-instruction">{wb.exercise}</div>
          <button
            className="lcv-btn-primary lcv-btn-full"
            onClick={onDone}
            disabled={navigationDisabled}>
            I'm Ready! →
          </button>
        </>
      )}
    </div>
  );
};

export default WorkbookReadyPhase;
